import React from 'react';
import { Section } from './ui/Section';
export function ProblemSection() {
  return <Section className="px-6 md:px-12 max-w-4xl mx-auto border-t border-[#d4a853]/10" data-id="element-177">
      <div className="space-y-8" data-id="element-178">
        <h2 className="font-serif text-3xl md:text-4xl font-semibold text-[#f0c674]" data-id="element-179">
          El problema no es que te falte voluntad o talento.
        </h2>

        <div className="space-y-6 text-lg text-gray-300 leading-relaxed font-sans" data-id="element-180">
          <p data-id="element-181">
            El problema es que el límite físico de tus ingresos es tu propio
            tiempo. Estás atrapado en la{' '}
            <strong className="text-[#d4a853] font-normal" data-id="element-182">
              "operatividad boba"
            </strong>
            : tareas repetitivas que cualquier software de $10 dólares podría
            hacer mejor que vos, pero que hoy te roban 4 horas diarias de
            enfoque estratégico.
          </p>

          <div className="p-8 border border-[#b8860b]/20 bg-[#111827]/50 rounded-sm relative overflow-hidden" data-id="element-183">
            <div className="absolute top-0 left-0 w-1 h-full bg-[#d4a853]/50" data-id="element-184" />
            <p className="relative z-10" data-id="element-185">
              Intentaste ser más productivo con técnicas Pomodoro o apps de
              listas, pero solo terminaste haciendo tareas irrelevantes más
              rápido. Sentís que si querés crecer, tenés que contratar gente, y
              eso en Argentina significa más drama, más impuestos y más
              problemas de gestión que no querés tener.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}